import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../components/Auth/AuthContext';
import { AdminProvider } from '../components/Admin/AdminContext';
import MainPage from './MainPage';
import GalleryPage from './GalleryPage';
import SpotDetailsPage from './SpotDetailsPage';
import ProfilePage from './Profile/ProfilePage';
import PublicProfilePage from './Profile/PublicProfilePage';
import ProfileDemo from './ProfileDemo';
import AdminPanel from './AdminPanel';

// Auth pages
import { 
  LoginPage, 
  RegisterPage, 
  VerifyEmailPage, 
  ForgotPasswordPage, 
  ResetPasswordPage 
} from './Auth';

// Protected Route component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

// Auth Route - redirects to home if already logged in
function AuthRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function AppRouter() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<MainPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/spot/:id" element={<SpotDetailsPage />} />
      <Route path="/profile/:username" element={<PublicProfilePage />} />
      <Route path="/demo-visites" element={<ProfileDemo />} />

      {/* Auth routes */}
      <Route path="/login" element={<AuthRoute><LoginPage /></AuthRoute>} />
      <Route path="/register" element={<AuthRoute><RegisterPage /></AuthRoute>} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Protected routes */}
      <Route 
        path="/profile" 
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        } 
      />

      {/* Admin routes */}
      <Route 
        path="/admin/*" 
        element={
          <AdminProvider>
            <AdminPanel />
          </AdminProvider>
        } 
      />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRouter;
